export default __webpack_public_path__ + "static/media/virgiliu-pacuretu.46078e42.png";